import { commonTripSagaWatcher } from './CommonTrip/saga';
import { tripFieldsSagaWatcher } from './FillTrip/saga';
import { headerSagaWatcher } from './Header/saga';
import { logoutSagaWatcher } from './LogoutBtn/saga';
import { scanerSagaWatcher } from './ScanerBtn/saga';
import { verifyPhoneWatcher } from './VerifyPhoneBtn/saga';
import { getWeightWatcher } from './WeightBtn/saga';
import { bookingModalWatcher } from './BookingModal/saga';

export const commonModuleSaga = [
  tripFieldsSagaWatcher,
  headerSagaWatcher,
  verifyPhoneWatcher,
  scanerSagaWatcher,
  commonTripSagaWatcher,
  getWeightWatcher,
  logoutSagaWatcher,
  bookingModalWatcher,
];
